import React from "react";
import Media from "react-media";
import { HeaderDesktop } from "../../../components/header/desktop/HeaderDesktop";
import { HeaderMobile } from "../../../components/header/mobile/HeaderMobile";
import { ChooseTerminalState } from "../../../states/ChooseTerminalState";
import "./ChooseTerminal.css";
import { Subscription } from "rxjs";
import { ITerminalsDto, TerminalsDto } from "../../../models/TerminalsDto";
import { SearchBarDesktop } from "../../../components/searchbar/desktop/SearchBarDesktop";
import { SearchBarMobile } from "../../../components/searchbar/mobile/SearchBarMobile";
import { SearchType } from "../../../components/searchbar/SearchType";
import { ITerminalDto } from "../../../models/TerminalDto";
import StateBadge from "../../../components/badge/StateBadge";
import CheckIcon from "../../../resources/wrappers/CheckIcon";
import { Button } from "@material-ui/core";
import { TidStatusDto } from "../../../models/TidStatusDto";
import { Pagination } from "../../../utils/Pagination";
import Skeleton from "react-loading-skeleton";
import { MposWebPortalApi } from "../../../services/api/MposWebPortalApi";
import { sessionStorageInstance } from "../../../services/storage/Storage";
import { AddUserRequest } from "../../../models/AddUserRequest";
import { Route } from "react-router-dom";
import { MposLoader } from "../../../components/loader/MposLoader";
import { TerminalOperationType } from "../../../utils/TerminalOperationTypeEnum";
import { TerminalUpdateOrRemoveRequest } from "../../../models/TerminalUpdateOrRemove";
import { IUserDto } from "../../../models/UserDto";
import { UserType } from "../../../utils/UserTypeEnum";
import * as querystring from "querystring";
import { GoogleTagManagerService } from "../../../services/analitycs/GoogleTagManagerService";
import { ProgressBar } from "../../../components/progress-bar/ProgressBar";
import StateContextProvider from "../../../context/StateContext";

export class ChooseTerminal extends React.Component<any, ChooseTerminalState> {
  private getTerminalsSubscription: Subscription | null = null;
  private email: string = "";
  private description: string = "";
  private tidOperation: TerminalOperationType | null = null;
  private pagination: Pagination<ITerminalDto>;
  private user: IUserDto | undefined;
  private terminalType: string;
  private mobilePosId: string | null = null;
  private alternativeTitle: string | null = null;

  constructor(props: any) {
    super(props);
    this.state = {
      termIdCounter: 0,
      terminalsDto: null,
      terminalList: null,
      terminalToShow: null,
      selectedElement: null,
      isLoading: false,
      buttonDisabled: true,
      searchTextEmpty: true,
      searchFilteredResultNumber: null,
      showLoader: false,
      showResultDialog: false,
      addUserResult: false,
      sameTerminalsType: false,
    };

    this.email = this.props.location.state.email;
    this.description = this.props.location.state.description;
    this.tidOperation = this.props.location.state.tidOperation;
    this.pagination = new Pagination(5);
    this.terminalType = this.props.location.state.terminalType;
    this.mobilePosId = this.props.location.state.mobilePosId;
    this.alternativeTitle = this.props.location.state.alternativeTitle;
    this.user = this.props.location.state.user;

    console.log("[ChooseTerminal] email: " + this.email + ", description: " + this.description + " and TID Operation: " + this.tidOperation);
  }

  componentDidMount() {
    this.setState({
      sameTerminalsType: StateContextProvider.getInstance().getProp("sameTerminalsType"),
    });

    console.log("[ChooseTerminal] Fetching data...");
    this.user = this.props.location.state.user;
    this.setState({ isLoading: true });
    this.getTerminalsSubscription = MposWebPortalApi.getInstance()
      .getTerminals()
      .subscribe(
        (terminalsDto: ITerminalsDto) => {
          if (this.state.sameTerminalsType) {
            this.setState({
              terminalsDto: terminalsDto,
              termIdCounter: (terminalsDto !== null && terminalsDto.terminals !== null) ? terminalsDto.terminals!.length : 0,
              terminalList: (terminalsDto !== null && terminalsDto.terminals !== null) ? this.sortArrayForTerminalId(terminalsDto.terminals!) : []
            });
            this.pagination.setInputData(this.sortArrayForTerminalId(terminalsDto.terminals!));
          } else {
            let terminalsDtoFiltered = new TerminalsDto(terminalsDto.terminals?.filter((t) => t.terminalType === this.terminalType));
            this.setState({
              terminalsDto: terminalsDtoFiltered,
              termIdCounter: terminalsDtoFiltered.terminals != null ? terminalsDtoFiltered.terminals.length : 0,
              terminalList: terminalsDtoFiltered.terminals !== null ? this.sortArrayForTerminalId(terminalsDtoFiltered.terminals) : [],
            });
            this.pagination.setInputData(this.sortArrayForTerminalId(terminalsDtoFiltered.terminals));
          }
          this.getTerminalsToShow();
          this.setState({ isLoading: false });
        },
        (error) => {
          console.log("[ChooseTerminal] Error when try to fetch data! " + JSON.stringify(error));
          this.setState({ terminalsDto: null });
          this.setState({ termIdCounter: 0 });
          this.setState({ terminalList: null });
          this.setState({ isLoading: false });
          this.setState({ terminalToShow: null });
        }
      );

    GoogleTagManagerService.getInstance().pushPageEvent(this.props.history.location.pathname, this.props.location.state.headerTitle.toLowerCase(), {});
  }

  componentWillUnmount() {
    if (this.getTerminalsSubscription != null) {
      this.getTerminalsSubscription.unsubscribe();
    }
  }

  componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<ChooseTerminalState>, snapshot?: any): void {
    if (this.props.location.state.terminalType && this.props.location.state.terminalType !== prevProps.location.state.terminalType) {
      window.location.reload();
    }
  }

  private desktopSearchBarValueProvided(value: string) {
    this.pagination.resetPaginator();
    let filteredInput = this.filterElements(value);
    console.log("[ChooseTerminal] Filtered size: " + filteredInput.length);
    this.setState({ searchFilteredResultNumber: filteredInput.length });
    this.setState({ searchTextEmpty: value === "" });
    this.pagination.setInputData(filteredInput);
    this.getTerminalsToShow();
  }

  private filterElements(filter: string): Array<ITerminalDto> {
    let elements = Array.from(this.state.terminalsDto?.terminals!);
    if (filter.length >= 3) {
      GoogleTagManagerService.getInstance().pushInteractionEvent(
        "RicercaOverlay",
        this.props.location.state.headerTitle + " terminale id",
        "search",
        "ricerca id terminale"
      );
      return elements.filter((obj) => {
        return obj.terminalId.includes(filter);
      });
    }

    return elements;
  }

  private getTerminalsToShow() {
    this.setState({ terminalToShow: this.pagination.getNext() });
  }

  private selectElement(terminal: ITerminalDto) {
    console.log("[ChooseTerminals][selectElement] Selected element: " + JSON.stringify(terminal));
    this.setState({ selectedElement: terminal });
    this.setState({ buttonDisabled: false });
  }

  private sortArrayForTerminalId(array: ITerminalDto[] | undefined): ITerminalDto[] {
    if (array !== undefined) {
      return array.sort((a, b) => {
        return b.terminalId > a.terminalId ? -1 : 1;
      });
    } else {
      return [];
    }
  }

  private startAddUserProcedure() {
    console.log("[ChooseTerminals][startAddUserProcedure] Add user!");
    // Retrieve contract code of superuser
    if (sessionStorageInstance.getData("user") !== null) {
      let user = JSON.parse(sessionStorageInstance.getData("user")!);
      // @ts-ignore
      let contractCode = user.contractCode;
      let addUserRequest = new AddUserRequest(
        contractCode,
        this.description,
        this.email,
        null,
        null,
        this.state.selectedElement?.terminalId && this.terminalType === "MPOS" ? this.state.selectedElement?.terminalId : this.mobilePosId,
        this.state.selectedElement?.terminalId && this.terminalType === "SOFTPOS" ? this.state.selectedElement?.terminalId : null
      );
      this.setState({ showLoader: true });
      MposWebPortalApi.getInstance()
        .addUser(addUserRequest)
        .subscribe(
          (result) => {
            console.log("[ChooseTerminal] Response: " + result);
            this.setState({ showLoader: false });
            this.setState({ showResultDialog: true });
            this.setState({ addUserResult: true });
            this.showAddUserResult();
          },
          (error) => {
            console.log("[ChooseTerminal] Response: " + JSON.stringify(error));
            this.setState({ showLoader: false });
            this.setState({ showResultDialog: true });
            this.setState({ addUserResult: false });
            this.showAddUserResult();
          }
        );
    }
  }

  private changeTidForUser(history: any) {
    console.log("[ChooseTerminals][changeTidForUser] Change TID user!");
    if (sessionStorageInstance.getData("user") !== null) {
      let user = JSON.parse(sessionStorageInstance.getData("user")!);
      let request = undefined;
      let queryParams: any;
      let username: string;
      if (this.tidOperation === TerminalOperationType.CHANGE_TERMINAL_ID_TO_ADMIN_USER) {
        request = new TerminalUpdateOrRemoveRequest(this.state.selectedElement?.terminalId!, user.username);
        username = user.username;
        queryParams = {
          userType: UserType.ADMIN,
          description: user.description !== undefined ? encodeURIComponent(user.description) : "",
        };
      } else {
        request = new TerminalUpdateOrRemoveRequest(this.state.selectedElement?.terminalId!, this.user?.username!);
        username = this.user?.username!;
        queryParams = {
          userType: UserType.STAFF,
          description: this.user?.description! !== undefined ? encodeURIComponent(this.user?.description!) : "",
        };
      }
      console.log("[changeTidForUser] Request: " + JSON.stringify(request));
      this.setState({ showLoader: true });
      MposWebPortalApi.getInstance()
        .updateTerminalToUser(request)
        .subscribe(
          (result) => {
            console.log("[changeTidForUser] Response: " + result);
            this.setState({ showLoader: false });
            if (this.tidOperation === TerminalOperationType.CHANGE_TERMINAL_ID_TO_ADMIN_USER) {
              //@ts-ignore
              queryParams.terminalStatus = TidStatusDto.ACTIVE;
              console.log("[changeTidForUser] ADMIN USER tid changed");
              window.history.pushState(null, "", "/");
              let link = `/users/${username}?${querystring.stringify(queryParams)}`;
              history.push("/users", {
                data: {
                  redirectTo: link,
                },
              });
            } else if (this.tidOperation === TerminalOperationType.CHANGE_TERMINAL_ID_TO_STAFF_USER) {
              //@ts-ignore
              queryParams.terminalStatus = TidStatusDto.ACTIVE;
              console.log("[changeTidForUser] STAFF USER tid changed");
              window.history.pushState(null, "", "/");
              let link = `/users/${username}?${querystring.stringify(queryParams)}`;
              history.push("/users", { data: { redirectTo: link } });
            }
          },
          (error) => {
            console.log("[changeTidForUser] Error: " + JSON.stringify(error));
            this.setState({ showLoader: false });
            history.push("/result", {
              isSuccess: false,
              button: "TORNA ALLE UTENZE",
              data: {
                from: "MobileSearchOverlay",
                operation: "changeTidForUser",
              },
            });
          }
        );
    }
  }

  private onDesktopSearchBarFocus() {
    if (this.state.searchFilteredResultNumber === null) {
      this.setState({
        searchFilteredResultNumber: this.state.terminalList?.length ?? 0,
      });
    }
  }

  private onDesktopSearchBarBlur() {
    if (this.state.searchTextEmpty === true) {
      this.setState({
        searchFilteredResultNumber: null,
      });
    }
  }

  render() {
    return (
      <div id={"main-container-choose-terminal"}>
        {!this.state.sameTerminalsType ? (
          this.tidOperation === TerminalOperationType.ADD_TERMINAL_ID_TO_USER || this.tidOperation === TerminalOperationType.CHOOSE_AGAIN ? (
            <ProgressBar value={this.tidOperation === TerminalOperationType.CHOOSE_AGAIN ? 83.33 : 100} />
          ) : null
        ) : null}
        <Media
          query="(max-width: 1064px)"
          render={() => {
            return <HeaderMobile showBack={true} showLogout={false} showTitle={true} title={this.props.location.state.headerTitle} />;
          }}
        />
        <Media
          query="(min-width: 1065px)"
          render={() => {
            return <HeaderDesktop showBack={true} showLogout={false} showTitle={true} title={this.props.location.state.headerTitle} />;
          }}
        />
        <div className={"choose-terminal-container-content"}>
          <div className={"choose-terminal-content"}>
            <p className={"choose-terminal-title"}>
              {this.state.sameTerminalsType
                ? "Assegna un ID Terminale"
                : this.alternativeTitle ?? "Assegna un ID Terminale " + (this.terminalType === "MPOS" ? "Mobile POS" : "SoftPOS")}
            </p>
            {this.state.isLoading ? (
              <div>
                <Media
                  query="(min-width: 1065px)"
                  render={() => {
                    return <Skeleton className={"choose-terminal-searchbar-skeleton"} />;
                  }}
                />
                <Media
                  query="(max-width: 1064px)"
                  render={() => {
                    return <Skeleton className={"choose-terminal-searchbar-skeleton"} />;
                  }}
                />
              </div>
            ) : (
              this.state.termIdCounter > 10 && (
                <div>
                  <Media
                    query="(min-width: 1065px)"
                    render={() => {
                      return (
                        <SearchBarDesktop
                          placeholder={"Cerca per ID Terminale"}
                          onFocus={() => {
                            this.onDesktopSearchBarFocus();
                          }}
                          onBlur={() => {
                            this.onDesktopSearchBarBlur();
                          }}
                          onValueChanged={(value: string) => {
                            this.desktopSearchBarValueProvided(value);
                          }}
                        />
                      );
                    }}
                  />
                  <Media
                    query="(max-width: 1064px)"
                    render={() => {
                      return (
                        <SearchBarMobile
                          values={this.sortArrayForTerminalId(this.state.terminalsDto?.terminals !== null ? this.state.terminalsDto?.terminals : [])}
                          type={SearchType.TERMINAL_LIST}
                          data={{
                            tidOperation: this.tidOperation,
                            email: this.email,
                            description: this.description,
                            headerTitle: this.props.location.state.headerTitle,
                            user: this.user,
                          }}
                          placeholder={"Cerca per ID Terminale"}
                          mobilePosId={this.mobilePosId}
                        />
                      );
                    }}
                  />
                </div>
              )
            )}
            <div className={"choose-terminal-list-container"}>
              <Media
                query="(max-width: 1064px)"
                render={() => {
                  return (
                    <p className={"choose-terminal-counter-element"}>
                      Hai <b>{this.state.termIdCounter}</b> ID Terminale disponibili
                    </p>
                  );
                }}
              />
              <Media
                query="(min-width: 1065px)"
                render={() => {
                  return this.state.searchFilteredResultNumber === null ? (
                    <p className={"choose-terminal-counter-element"}>
                      Hai <b>{this.state.termIdCounter}</b> ID Terminale disponibili
                    </p>
                  ) : this.state.searchFilteredResultNumber === 1 ? (
                    <p className={"choose-terminal-counter-element"}>
                      <b>1</b> risultato trovato
                    </p>
                  ) : (
                    <p className={"choose-terminal-counter-element"}>
                      <b>{this.state.searchFilteredResultNumber}</b> risultati trovati
                    </p>
                  );
                }}
              />
              {[
                this.state.isLoading && (
                  <div className={"choose-terminal-terminal-table"}>
                    {[
                      <Skeleton className={"choose-terminal-element-skeleton"} />,
                      <Skeleton className={"choose-terminal-element-skeleton"} />,
                      <Skeleton className={"choose-terminal-element-skeleton"} />,
                      <Skeleton className={"choose-terminal-element-skeleton"} />,
                      <Skeleton className={"choose-terminal-element-skeleton"} />,
                    ]}
                  </div>
                ),
                !this.state.isLoading && this.state.terminalToShow !== null && (
                  <div className={"choose-terminal-terminal-table"}>
                    {this.state.terminalToShow?.map((value: ITerminalDto, index: number) => {
                      return (
                        <div
                          key={index}
                          id={value.terminalId}
                          className={
                            value.tidStatus === TidStatusDto.SUSPENDED
                              ? "choose-terminal-terminal-table-element-disabled"
                              : this.state.selectedElement !== null && this.state.selectedElement.terminalId === value.terminalId
                                ? "choose-terminal-terminal-table-element-selected"
                                : "choose-terminal-terminal-table-element"
                          }
                          onClick={
                            value.tidStatus === TidStatusDto.SUSPENDED
                              ? undefined
                              : () => {
                                this.selectElement(value);
                              }
                          }>
                          <div className={"choose-terminal-table-element-content"}>
                            <div className={"choose-terminal-table-element-content-one"}>
                              <p
                                className={
                                  value.tidStatus === TidStatusDto.SUSPENDED ? "choose-terminal-terminal-id-suspended" : "choose-terminal-terminal-id"
                                }>
                                {value.terminalId}
                              </p>
                              <StateBadge
                                badgeStateText="non assegnato"
                                userState={
                                  value.users === undefined || (value.users !== undefined && value.users?.length === 0)
                                    ? TidStatusDto.NOT_ASSIGNED
                                    : value.tidStatus
                                }
                              />
                            </div>
                            <div className={"choose-terminal-table-element-content-two"}>
                              {this.state.selectedElement === null || this.state.selectedElement.terminalId !== value.terminalId ? null : (
                                <CheckIcon width={"21px"} heigth={"16px"} color={"#000000"} />
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                    {this.pagination.hasMoreElements() && (
                      <Button
                        id={"choose-terminal-show-more-button"}
                        onClick={() => {
                          this.getTerminalsToShow();
                        }}
                        disableRipple>
                        {"Mostra di più".toUpperCase()}
                      </Button>
                    )}
                  </div>
                ),
              ]}
            </div>
          </div>
          <Route
            render={({ history }) => {
              return (
                <Button
                  id={"choose-terminal-confirm-button"}
                  className={
                    this.state.terminalToShow !== null && this.state.terminalToShow.length === this.state.terminalList?.length
                      ? "choose-terminal-confirm-button-margin"
                      : ""
                  }
                  type={"button"}
                  disabled={this.state.buttonDisabled}
                  onClick={() => {
                    if (this.tidOperation === TerminalOperationType.ADD_TERMINAL_ID_TO_USER) {
                      console.log("[ChooseTerminal] Add User!");
                      this.startAddUserProcedure();
                    } else if (this.tidOperation === TerminalOperationType.CHOOSE_AGAIN) {
                      history.push("/chooseTerminal", {
                        email: this.email,
                        headerTitle: "Crea nuova utenza",
                        alternativeTitle: "Ora assegna un ID Terminale SoftPOS",
                        tidOperation: TerminalOperationType.ADD_TERMINAL_ID_TO_USER,
                        terminalType: "SOFTPOS",
                        mobilePosId: this.state.selectedElement?.terminalId ?? null,
                        description: this.description,
                      });
                    } else {
                      console.log("[ChooseTerminal] Change tid for User!");
                      this.changeTidForUser(history);
                    }
                  }}>
                  {this.tidOperation === TerminalOperationType.CHOOSE_AGAIN ? "AVANTI" : "CONFERMA"}
                </Button>
              );
            }}
          />
        </div>
        {
          // @ts-ignore
          <MposLoader show={this.state.showLoader} />
        }
      </div>
    );
  }

  private showAddUserResult() {
    this.props.history.push("/result", {
      isSuccess: this.state.addUserResult,
      title: "Hai creato un nuovo membro del tuo staff!",
      button: "VEDI ELENCO UTENZE",
      data: {
        from: "ChooseTerminal",
        operation: "addUser",
        email: this.email,
        result: this.state.addUserResult,
      },
    });
  }
}
